import React from 'react';

import {
  FormCheckbox,
  FormSelect,
} from '@uncinc/uncinc-react-kitchen-sink';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

export interface Filter {
  [key: string]: string;
}

export interface FilterProps {
  filters: Filter[];
  filter: ImmutableEntity<any>;
  defaultValue: Filter[] | any;
  onChange: (key: string, value: any) => void;
}

import './style.scss';

const ViewFilter: React.FC<FilterProps> = (props) => {
  const {
    filters, filter, defaultValue, onChange,
  } = props;
  const filterLabel = filter.getIn(['expose', 'label']);
  const filterIdentifier = filter.getIn(['expose', 'identifier']);
  const filterPlaceholder = filter.getIn(['expose', 'description']);
  const filterField = filter.get('field');
  let filterOptions = filter.get('options');

  filterOptions = filterOptions?.sort((a: ImmutableEntity<any>, b: ImmutableEntity<any>) => a.get('label').localeCompare(b.get('label')));

  switch (filter.get('plugin_id')) {
    case 'boolean': {
      return (
        <div className="ViewFilters__filter">
          <FormCheckbox
            title={filterLabel}
            fieldName={filterField}
            onChange={(value: any) => onChange(filterIdentifier, value ? 1 : 0)}
          />
        </div>
      );
    }

    case 'combine':
    case 'entity_reference_tree_inline_filter': {
      // Get our passed Default filter first.
      const defaultValueOption = filterOptions.find((item: ImmutableEntity<any>) => (
        item.get('value') === `${defaultValue}`
      )) || null;

      // Get our view default value as fallback.
      const viewDefaultValueOption = filterOptions.find((item: ImmutableEntity<any>) => (
        item.get('value') === filters[filterIdentifier]
      )) || null;

      // Set the selected option.
      let selectedOption = defaultValueOption ? defaultValueOption.toJS() : null;
      if (!selectedOption) {
        selectedOption = viewDefaultValueOption ? viewDefaultValueOption.toJS() : null;
      }

      return (
        <div className={`ViewFilters__filter ${filterField}`}>
          <FormSelect
            title={filterLabel}
            fieldName={filterField}
            placeholder={filterPlaceholder}
            options={filterOptions.toJS()}
            selectedOption={selectedOption}
            onChange={(value: number) => onChange(filterIdentifier, value)}
            defaultFilters={filters[filterIdentifier]}
          />
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

export default ViewFilter;
